interface RecipeNotificationDependencies {
  notifyRecipeCreated: (recipeId: string, recipeTitle?: string) => Promise<void>;
}

export const notifyRecipeCreatedSafely = (
  dependencies: RecipeNotificationDependencies,
  recipeId: string,
  recipeTitle?: string
): void => {
  void dependencies.notifyRecipeCreated(recipeId, recipeTitle);
};
